export default function startDateCalculator(daysFilter) {
  if (daysFilter > 0) {
    return new Date().setDate(new Date().getDate() - daysFilter) / 1000;
  }

  return "";
}
